import { ReactNode } from 'react';

export enum Sides {
  BOTTOM = 'bottom',
  TOP = 'top',
}

export interface IConfig {
  duration: number;
  side: Sides.TOP | Sides.BOTTOM;
  triangleOffset: number;
  tipMinWidth: number;
  tipMaxWidth: number;
  tipOffset?: number;
}

export interface TooltipProps {
  children?: any;
  text?: string;
  content?: ReactNode;
  config?: IConfig;
  reversed?: boolean;
  additionalOffset?: number;
  className?: string;
  withTriangle?: boolean;
  unmountOnExit?: boolean;
  initialShouldShow?: boolean;
  useReactPortal?: boolean;
}
